import { forwardRef, type ReactNode } from "react";
import { Lock } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";

export type PaywallButtonProps = ButtonProps & {
  locked: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
};

const PaywallButton = forwardRef<HTMLButtonElement, PaywallButtonProps>(
  ({ locked, leftIcon, rightIcon, children, ...props }, ref) => {
    return (
      <Button ref={ref} {...props}>
        {locked ? <Lock aria-hidden="true" /> : leftIcon}
        {children}
        {!locked && rightIcon}
      </Button>
    );
  }
);
PaywallButton.displayName = "PaywallButton";

export default PaywallButton;
